import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { query$ } from '@atlassian/jira-software-swag/src/services/query/index.tsx';
import type { IssueId } from '@atlassian/jira-software-board-common/src/index.tsx';
import type { FilteredCardIdsLoadGql } from '../../model/work/work-types.tsx';

const filteredCardsQuery = 'FilteredCardIds';

export const getQuery = () => `
    query ${filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!, $jql: String) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
                filterJql: $jql
            )
        }
    }
`;

interface Params {
	boardId: string;
	issueIds: IssueId[];
	customFilterIds: string[];
	jql: string | null;
}

export function fetchTMPFilteredCardIds({
	boardId,
	issueIds,
	customFilterIds,
	jql,
}: Params): ObservableType<string[]> {
	return query$<FilteredCardIdsLoadGql>('', filteredCardsQuery, getQuery(), {
		boardId,
		issueIds,
		customFilterIds,
		jql,
	}).flatMap(({ boardScope }) => Observable.of(boardScope.filteredCardIds));
}
